import intl from "react-intl-universal";
import { TbAlertTriangle } from "react-icons/tb";
import { ValutDialog } from "../../../../Components/Molecules/ValutDialog";

/**
 * Confirm dialog for BaaS console destructive / reversible actions.
 * Reuses ValutDialog (gold, not native alert / MUI purple).
 */
export const BaasConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = null,
  busyLabel = null,
  busy = false,
  confirmDisabled = false,
  error = "",
  children = null,
}) => {
  const handleClose = () => {
    if (busy) return;
    onClose?.();
  };

  return (
    <ValutDialog
      open={open}
      onClose={handleClose}
      title={title}
      icon={<TbAlertTriangle className="h-4 w-4" />}
      maxWidth="sm"
      disableBackdropClose={busy}
      footer={
        <>
          <button
            type="button"
            className="btn-outline w-full sm:w-auto"
            onClick={handleClose}
            disabled={busy}
          >
            {intl.get("common.cancel")}
          </button>
          <button
            type="button"
            className="btn-primary w-full sm:w-auto"
            onClick={() => {
              void onConfirm?.();
            }}
            disabled={busy || confirmDisabled}
          >
            {busy ? busyLabel || confirmLabel : confirmLabel}
          </button>
        </>
      }
    >
      {message ? (
        <p className="text-sm text-gray-600 dark:text-gray-300">{message}</p>
      ) : null}
      {children}
      {error ? (
        <p
          role="alert"
          className="mt-4 rounded-xl border border-red-200 bg-red-50/80 px-4 py-3 text-sm text-red-700 dark:border-red-900/50 dark:bg-red-950/30 dark:text-red-300"
        >
          {error}
        </p>
      ) : null}
    </ValutDialog>
  );
};
